export default __webpack_public_path__ + "static/media/PV-HOODIE-DETAIL-BACK.7603b8bd.png";